import { Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';

type BaseItemProps = {
  isSelected: boolean;
};

export const Container = styled.div<BaseItemProps>`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
  min-height: 117px;

  display: flex;
  align-items: center;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: #0b29fb;
      border-width: 2px;
    `}
`;

export const InputWrapper = styled.div`
  width: 45px;
  height: 100%;
  background: #eff0f0;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputSelect = styled.div<BaseItemProps>`
  width: 18px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: #00995d;
      border: 1px solid #00995d;
    `}
`;

export const BaseInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfosDetailWrapper = styled.div``;

export const InfoDetailWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BaseName = styled.span<BaseItemProps>`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;

export const BaseAddress = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #3d3d3d;
`;

export const TitleDetail = styled.span<BaseItemProps>`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #3d3d3d;
`;

export const DetailInfo = styled.span<BaseItemProps>`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 10px;
  line-height: 15px;
  color: #3d3d3d;
`;

export const Divisor = styled.div`
  border-bottom: 2px rgba(218, 218, 218, 0.8) dashed;
  width: 80%;
  margin: 12px 0;
`;

export const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;

export const InfosWrapper = styled.div`
  padding: 12px;
  flex: 1;
`;
